import Vue from 'vue';
import Vuex from 'vuex';
import app from './app';
import user from './user';

Vue.use(Vuex);

export default new Vuex.Store({
	state: {},
	modules: {
		app,
		user
	},
	getters: {},
	strict: false
})
